import React, { useEffect, useRef, useState } from "react";
import UserProfileLayout from "markup/Layout/UserProfileLayout";
import { makeStyles } from "@material-ui/core/styles";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import * as advertEndpoint from "modules/Advert/_redux/advertEndpoint";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import Stepper from "@material-ui/core/Stepper";
import TextField from "@material-ui/core/TextField";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Profilesidebar from "markup/Element/Profilesidebar";
import "./CreateAdvert.css";
import CreateAdvertFilters from "./parts/CreateAdvertFilters";
import ListingTypeSelect from "./parts/ListingTypeSelect";
import ProvinceDistrictSelect from "./parts/locations/ProvinceDistrictSelect";
import { Hidden } from "@material-ui/core";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { formatNumberWithCommas } from "helpers/FormatNumbersWithComma";
import { getCategoryVisual } from "helpers/categoryVisual";
import { useDropzone } from "react-dropzone";

const successImage = require("images/success_message.png");

// Logged-in seller flow. Mirrors CreateAdvert.js but writes kind=seller
// and collects the seller-only fields (price, condition, tradeable,
// contactPreference) plus up to 8 photos uploaded after creation via
// uploadAdvertImages.
function getSteps() {
  return [
    "Kategori",
    "Filtre",
    "İçerik",
    "Fotoğraflar",
    "Fiyat & Durum",
    "Konum",
    "İletişim",
    "Yayınla",
  ];
}

function CreateSellerAdvert(props) {
  const classes = useStyles();
  const steps = getSteps();
  const [activeStep, setActiveStep] = useState(0);
  const [success, setSuccess] = useState(false);
  const [files, setFiles] = useState([]);
  const submitting = useRef(false);

  useEffect(() => {
    // Sihirbaza her girişte formu sıfırla; aksi halde alıcı↔satıcı geçişinde
    // başlık/detay/filtre gibi alanlar redux'ta kalıyor.
    props.clearNewlyCreatedAdvert("seller");
    window.scrollTo(0, 0);
  }, []);

  const goToStep = (i) => {
    if (i < activeStep) setActiveStep(i);
  };
  const stepHeaderProps = (i) => ({
    onClick: () => goToStep(i),
    style: { cursor: i < activeStep ? "pointer" : "default" },
  });

  const { categories, newAdvert } = useSelector((state) => ({
    categories: state.category.categories,
    newAdvert: state.advert.newAdvert,
  }));

  const onDrop = (accepted) =>
    setFiles((prev) => [...prev, ...accepted].slice(0, 8));
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: true,
  });

  const displayToastError = (m) => toast.error(m);
  const handleNext = () => setActiveStep((s) => s + 1);
  const handleBack = () => setActiveStep((s) => s - 1);
  const handleReset = () => setActiveStep(0);

  const handleChange = (e) => {
    let { name, value, checked, type } = e.target;
    if (type === "checkbox") value = checked;

    if (name === "price") {
      const raw = String(value).replace(/,/g, "");
      if (!isNaN(raw) || raw === "") {
        props.editNewAdvert("displayPrice", formatNumberWithCommas(raw));
        return props.editNewAdvert("price", Number(raw));
      }
    }
    props.editNewAdvert(name, value);
  };

  const toggleContactPref = (pref) => {
    const current = newAdvert.contactPreference || [];
    const next = current.includes(pref)
      ? current.filter((p) => p !== pref)
      : [...current, pref];
    if (next.length === 0) return; // require at least one
    props.editNewAdvert("contactPreference", next);
  };

  const selectCategory = (category) => {
    props.selectCategory(category);
    handleNext();
  };

  const handleSubmit = async () => {
    if (submitting.current) return;
    submitting.current = true;
    try {
      // newAdvert paylaşılan blob: hem alıcı (priceMin/priceMax) hem satıcı
      // alanlarını taşır. Satıcı şeması alıcı fiyat alanlarını reddettiği için
      // ("priceMin is not allowed") gönderimden önce ayıkla.
      const {
        displayPrice,
        priceMin,
        priceMax,
        displayPriceMin,
        displayPriceMax,
        ...rest
      } = newAdvert;
      const payload = { ...rest, kind: "seller" };
      const res = await advertEndpoint.createAdvert(payload);
      const created = res.data && (res.data.advert || res.data);
      const slug = created && (created.slug || created._id);
      if (slug && files.length > 0) {
        try {
          await advertEndpoint.uploadAdvertImages(slug, files);
        } catch (err) {
          toast.warn(
            "İlan oluşturuldu fakat bazı fotoğraflar yüklenemedi."
          );
        }
      }
      window.scrollTo(0, 0);
      setSuccess(true);
      props.clearNewlyCreatedAdvert("seller");
    } catch (err) {
      toast.error(
        (err && err.response && err.response.data && err.response.data.message) ||
          "İlan oluşturulamadı."
      );
    } finally {
      submitting.current = false;
    }
  };

  if (success) {
    return (
      <UserProfileLayout>
        <div className="page-content">
          <div className="d-flex flex-column align-items-center mt-5 mb-5">
            <img src={successImage} alt="" width={200} />
            <h2>Satıcı ilanınız başarıyla kaydedildi.</h2>
            <div>
              <Link to={"./"} className="site-button button-sm float-right">
                Anasayfa
              </Link>
            </div>
          </div>
        </div>
      </UserProfileLayout>
    );
  }

  const contactPref = newAdvert.contactPreference || [];

  return (
    <UserProfileLayout>
      <div className="page-content create-advert-page">
        <div className="content-block container">
          <div className="row pt-5">
            <Hidden smDown>
              <Profilesidebar {...props} />
            </Hidden>
            <div className="col-sm-12 col-md-8">
              <div
                className={`${classes.root} create-advert-card`}
                style={{ "--advert-accent": "#1ec28b" }}
              >
                <div className="create-advert-head">
                  <span className="create-advert-head__badge">Satılık</span>
                  <h3 className="create-advert-head__title">
                    Satıcı İlanı Oluştur
                  </h3>
                </div>
                <Stepper activeStep={activeStep} orientation="vertical">
                  <Step key={1}>
                    <StepLabel {...stepHeaderProps(0)}>Kategori seç</StepLabel>
                    <StepContent>
                      <p>Sattığınız ürünün kategorisini seçerek devam edin.</p>
                      <div className="category-tiles">
                        {categories.map((category, index) => {
                          const { Icon, color, image } =
                            getCategoryVisual(category);
                          return (
                            <div
                              key={index}
                              onClick={() => selectCategory(category)}
                              className="selectableCategory"
                            >
                              <div
                                style={{
                                  width: 56,
                                  height: 56,
                                  borderRadius: "50%",
                                  border: image ? "none" : `3px solid ${color}`,
                                  overflow: "hidden",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: "0 auto 8px",
                                  boxShadow: `0 8px 16px -8px ${color}`,
                                }}
                              >
                                {image ? (
                                  <img
                                    src={image}
                                    alt={category.name}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <Icon size={26} color={color} />
                                )}
                              </div>
                              <div style={{ fontWeight: "bold" }}>
                                {category.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </StepContent>
                  </Step>

                  <Step key={2}>
                    <StepLabel {...stepHeaderProps(1)}>Filtre</StepLabel>
                    <StepContent>
                      <p>
                        Aramada üst sıralarda yer almak için ilan ile ilgili
                        filtre değerlerini seçin.
                      </p>
                      {newAdvert.selectedCategory && (
                        <CreateAdvertFilters
                          filters={newAdvert.selectedCategory.filters}
                        />
                      )}
                      <div className={classes.actionsContainer}>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Geri
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            Object.keys(newAdvert.filters || {}).length > 0
                              ? handleNext()
                              : displayToastError("Lütfen filtreleri doldurun.")
                          }
                          className={classes.button}
                        >
                          İleri
                        </Button>
                      </div>
                    </StepContent>
                  </Step>

                  <Step key={3}>
                    <StepLabel {...stepHeaderProps(2)}>İçerik</StepLabel>
                    <StepContent>
                      <p>
                        Satışa çıkardığınız ürün için açıklayıcı bir başlık ve
                        detay yazın.
                      </p>
                      <ListingTypeSelect />
                      <div className="d-flex flex-column">
                        <TextField
                          type="text"
                          name="title"
                          variant="outlined"
                          label="İlan Başlığı"
                          onChange={handleChange}
                          value={newAdvert.title}
                          style={{ width: "100%" }}
                        />
                        <TextField
                          type="text"
                          name="body"
                          variant="outlined"
                          label="İlan Detayları"
                          multiline
                          rows={10}
                          onChange={handleChange}
                          value={newAdvert.body}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className={classes.actionsContainer}>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Geri
                        </Button>
                        <Button
                          disabled={
                            !newAdvert.title || !newAdvert.body
                          }
                          variant="contained"
                          color="primary"
                          onClick={handleNext}
                          className={classes.button}
                        >
                          İleri
                        </Button>
                      </div>
                    </StepContent>
                  </Step>

                  <Step key={4}>
                    <StepLabel {...stepHeaderProps(3)}>Fotoğraflar</StepLabel>
                    <StepContent>
                      <p>
                        Ürünün net fotoğraflarını ekleyin. En fazla 8 görsel
                        yükleyebilirsiniz.
                      </p>
                      <div
                        {...getRootProps()}
                        style={{
                          border: "2px dashed #1EC28B",
                          borderRadius: 12,
                          padding: 28,
                          textAlign: "center",
                          background: isDragActive ? "#E6F9F1" : "#fafafa",
                          cursor: "pointer",
                        }}
                      >
                        <input {...getInputProps()} />
                        <p style={{ margin: 0 }}>
                          {isDragActive
                            ? "Bırakın, yüklensin..."
                            : "Sürükleyin veya tıklayın"}
                        </p>
                      </div>
                      <div className="d-flex flex-row flex-wrap mt-3">
                        {files.map((f, idx) => (
                          <div
                            key={idx}
                            style={{
                              position: "relative",
                              width: 96,
                              height: 96,
                              marginRight: 8,
                              marginBottom: 8,
                              borderRadius: 8,
                              overflow: "hidden",
                              border: idx === 0 ? "3px solid #1EC28B" : "1px solid #ddd",
                            }}
                          >
                            <img
                              src={URL.createObjectURL(f)}
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                      <div className={classes.actionsContainer}>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Geri
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            files.length > 0
                              ? handleNext()
                              : displayToastError(
                                  "En az bir fotoğraf ekleyin."
                                )
                          }
                          className={classes.button}
                        >
                          İleri
                        </Button>
                      </div>
                    </StepContent>
                  </Step>

                  <Step key={5}>
                    <StepLabel {...stepHeaderProps(4)}>Fiyat & Durum</StepLabel>
                    <StepContent>
                      <p>İstediğiniz fiyatı ve ürün durumunu belirtin.</p>
                      <div className="row">
                        <div className="col-sm-12 col-md-6">
                          <TextField
                            type="text"
                            name="price"
                            variant="outlined"
                            label="Fiyat (₺)"
                            onChange={handleChange}
                            value={newAdvert.displayPrice}
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-sm-12 col-md-6">
                          <TextField
                            select
                            name="condition"
                            variant="outlined"
                            label="Ürün Durumu"
                            onChange={handleChange}
                            value={newAdvert.condition || ""}
                            style={{ width: "100%" }}
                          >
                            <MenuItem value="new">Sıfır</MenuItem>
                            <MenuItem value="used">İkinci El</MenuItem>
                            <MenuItem value="refurbished">Yenilenmiş</MenuItem>
                          </TextField>
                        </div>
                      </div>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={!!newAdvert.tradeable}
                            onChange={(e) =>
                              props.editNewAdvert("tradeable", e.target.checked)
                            }
                            color="primary"
                          />
                        }
                        label="Takasa açık"
                      />
                      <div className={classes.actionsContainer}>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Geri
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            if (!newAdvert.price || newAdvert.price <= 0)
                              return displayToastError(
                                "Geçerli bir fiyat girin."
                              );
                            if (!newAdvert.condition)
                              return displayToastError(
                                "Ürün durumunu seçin."
                              );
                            handleNext();
                          }}
                          className={classes.button}
                        >
                          İleri
                        </Button>
                      </div>
                    </StepContent>
                  </Step>

                  <Step key={6}>
                    <StepLabel {...stepHeaderProps(5)}>Konum</StepLabel>
                    <StepContent>
                      <p>İlanınızın yayınlanacağı il ve ilçeyi seçin.</p>
                      <div className="d-flex flex-column">
                        <ProvinceDistrictSelect />
                      </div>
                      <div className={classes.actionsContainer}>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Geri
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            newAdvert.location && newAdvert.location.province
                              ? handleNext()
                              : displayToastError("Lütfen konumu giriniz.")
                          }
                        >
                          Tamamla
                        </Button>
                      </div>
                    </StepContent>
                  </Step>

                  <Step key={7}>
                    <StepLabel {...stepHeaderProps(6)}>İletişim</StepLabel>
                    <StepContent>
                      <p>Alıcılar size nasıl ulaşsın?</p>
                      <div className="d-flex flex-row mb-3">
                        {["message", "phone"].map((pref) => (
                          <div
                            key={pref}
                            onClick={() => toggleContactPref(pref)}
                            style={{
                              padding: "8px 16px",
                              marginRight: 8,
                              borderRadius: 999,
                              border: "1px solid #1EC28B",
                              cursor: "pointer",
                              background: contactPref.includes(pref)
                                ? "#1EC28B"
                                : "transparent",
                              color: contactPref.includes(pref)
                                ? "#fff"
                                : "#1EC28B",
                              fontWeight: 600,
                            }}
                          >
                            {pref === "message" ? "Mesaj" : "Telefon"}
                          </div>
                        ))}
                      </div>
                      <div className={classes.actionsContainer}>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Geri
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            contactPref.length === 0
                              ? displayToastError(
                                  "En az bir iletişim yöntemi seçin."
                                )
                              : handleNext()
                          }
                        >
                          Tamamla
                        </Button>
                      </div>
                    </StepContent>
                  </Step>

                  <Step key={8}>
                    <StepLabel {...stepHeaderProps(7)}>Yayınla</StepLabel>
                    <StepContent>
                      <p>
                        Yayınla'ya bastığınızda ilan moderasyon sırasına alınır
                        ve onaylandığında size bildirilir.
                      </p>
                      <div className={classes.actionsContainer}>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Geri
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          Yayınla
                        </Button>
                      </div>
                    </StepContent>
                  </Step>
                </Stepper>

                {activeStep === steps.length && (
                  <div className={classes.resetContainer}>
                    <p>Tüm adımlar tamamlandı</p>
                    <Button onClick={handleReset} className={classes.button}>
                      Sayfayı Yenile
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserProfileLayout>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

export default connect(null, {
  ...advertRedux.actions,
  ...categoryRedux.actions,
})(CreateSellerAdvert);
